// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","lg_grid":"fas_lg_grid","article_tile_grid_root":"fas_article_tile_grid_root","promo_tile_container":"fas_promo_tile_container"};